/**
 * One fetch per exercise per page load. The picks tray, the new-sheet form and the
 * editor all want titles and minutes for a handful of ids; asking the server again for
 * each would make opening the tray feel slow for no reason.
 */
import type { ExerciseDetail } from '@studio/shared';
import { api } from './api';

const cache = new Map<string, Promise<ExerciseDetail | null>>();

export function exerciseInfo(id: string): Promise<ExerciseDetail | null> {
  let hit = cache.get(id);
  if (!hit) {
    hit = api.anyExercise(id).catch(() => {
      // a failure is not remembered, so the next call tries again
      cache.delete(id);
      return null;
    });
    cache.set(id, hit);
  }
  return hit;
}
